import { RootState } from '@/store/main';

export const selectChannelAdmins = (state: RootState) => state.channelAdmins.admins;
export const selectTemporarilyLockedEmails = (state: RootState) => state.channelAdmins.temporarilyLockedEmails;
export const selectWorkingPermissions = (state: RootState) => state.channelAdmins.workingPermissions;
export const selectActiveChannelProducersAndPresenters = (state: RootState) =>
  state.channelAdmins.activeChannelProducersAndPresenters;
